export interface ActivityType {
  id: number;
  name: string;
  color?: string;
  label?: string;
}

export interface ActivityPriority {
  id: number;
  name: string;
  color?: string;
  label?: string;
}


export type RecurrenceRule = 'NONE' | 'DAILY' | 'WEEKLY' | 'MONTHLY' | 'YEARLY' | 'CUSTOM';

export interface IActivity {
  id: number;
  proposal_id: number | null;
  title: string;
  start_date: string;
  end_date: string;
  description: string;
  created_at: string;
  updated_at: string;
  status_id: number;
  location?: string;
  participants?: string[]; // Array of contact IDs
  notes?: string;
  assignee_id?: number | null;  
  priority?: 'high' | 'medium' | 'low';
  created_by_id?: number;
  estimated_hours?: number;
  actual_hours?: number;
  is_recurring?: boolean;
  type_id: number;
  organization_id?: number | null;
  
  // Recurrence fields
  parent_id?: number | null;  // For recurring events - links to the original
  recurrence_rule?: RecurrenceRule;
  recurrence_end_date?: string | null; // When the recurrence should end
  recurrence_interval?: number; // e.g., every 2 weeks
  recurrence_days?: number[]; // For weekly: [1,3,5] for Mon, Wed, Fri
  recurrence_month_day?: number; // For monthly: day of month
  recurrence_weekday?: number; // For monthly: day of week (0-6)
  recurrence_weekday_ordinal?: number; // For monthly: 1=first, 2=second, etc.
}

// Default activity types with colors
export const defaultActivityTypes: ActivityType[] = [
  { id: 1, name: 'meeting', color: '#7e57c2'}, // Purple
  { id: 2, name: 'viewing', color: '#e69138' }, // Orange  
  { id: 3, name: 'task', color: '#4a86e8' }, // Blue
  { id: 4, name: 'event', color: '#808000' }, // Olive
];

// Default activity types with colors
export const defaultActivityPriority: ActivityPriority[] = [
  {  id: 1, name: 'low', color: '#4a86e8', label: 'Low', },
  {  id: 2, name: 'medium', color: '#ffbf00', label: 'Medium', },
  {  id: 3, name: 'high', color: '#cd5c5c', label: 'High', },
];
  
export type ActivityCreate = Omit<IActivity, 'id' | 'created_at' | 'updated_at'>;
export type ActivityUpdate = Partial<ActivityCreate>;